import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { GooSpinner } from 'react-spinners-kit';

import { ALLOWED_APP_THEMES } from '../../constants/section-constants/type-constants';

/**
 * @param isEmbeded => default 'false', effects the 100% height
 */
const Loader = ({ session, eventDetails, isEmbeded = false }) => {
  return (
    <div className={isEmbeded ? 'embeded-loader-section' : 'loader-section'}>
      <GooSpinner
        size={80}
        color={
          !_.isEmpty(eventDetails)
            ? _.isEqual(ALLOWED_APP_THEMES.dark, session?.theme)
              ? eventDetails?.darkthemecolor
              : eventDetails?.themecolor
            : '#2676ea'
        }
        loading={true}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    session: state.session,
    eventDetails: state.eventDetails
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
